import { render, staticRenderFns } from "./ReservationDeleted.vue?vue&type=template&id=0dc8fc50"
import script from "./ReservationDeleted.vue?vue&type=script&lang=js"
export * from "./ReservationDeleted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports